// ============================================================
// versao.js — versão do sistema, num lugar só
//
// Aparece na tela de acesso. Ficava escrita à mão lá dentro e envelheceu:
// marcava 1.0 depois de meses de mudança.
//
// Como numerar, para não virar enfeite:
//   terceiro número  correções e ajustes de tela, sem função nova
//   segundo número   função nova no ar para quem usa
//   primeiro número  mudança grande o bastante para exigir aviso e treino
//
// O reconhecimento facial, quando entrar oficialmente em operação, é caso
// do segundo número.
//
// O aplicativo tem a versão dele em src/constants/versao.js, e as duas
// sobem juntas: para quem usa é um sistema só. O campo version do app.json
// é outra coisa e não acompanha, porque ele entra na impressão digital que
// liga uma atualização ao aplicativo já instalado.
// ============================================================

export const VERSAO = "1.1.0";
